<script setup lang="ts">
useHead({ title: 'Platba faktur pomocí kryptoměn' })

const contactRef = ref()
function scrollToContact () {
  contactRef.value.scrollIntoView({ behavior: 'smooth' })
}

const invoiceHighlights = [
  {
    title: 'Rychlost',
    text: 'Začněte přijímat platby v kryptoměnách bez nutnosti integrovat platební bránu.',
    icon: 'i-fubex-stopwatch',
  },
  {
    title: 'Směna',
    text: 'Přijměte platbu v kryptoměnách a obdržte české koruny přímo na váš účet.',
    icon: 'i-fubex-exchange',
  },
  {
    title: 'Bezpečnost',
    text: ' Transakce jsou zabezpečené a veškeré procesy splňují zákonné náležitosti.',
    icon: 'i-fubex-safe',
  },
  {
    title: 'Licence',
    text: 'Není potřeba žádná speciální licence ani rozšiřovat živnostenské oprávnění.',
    icon: 'i-fubex-licence',
  },

]
</script>

<template>
  <div>
    <div bg-gradient-to-br dark:bg-gradient-to-b from="primary-200 dark:neutral-50" via-primary-50 dark="via-50% via-primary-50" to="primary-100 dark:neutral-100">
      <div fubex-container h-auto>
        <div :data-test="getCypressId('body-header')" grid grid-cols="1 md:2" justify-between gap-50px py-64px lg:py-120px>
          <div paragraph-md text-neutral-900 flex flex-col gap-8px>
            <h1 display-sm sm:display-lg font-700 text-neutral-900>
              Platba faktur kryptoměnami
            </h1>
            <p mt-24px mb-16px max-w-480px>
              Přijímejte platby v kryptoměnách jednoduše a bez rizik. Využijte potenciálu moderních technologií a oslovte nové zákazníky.
            </p>
            <p mb-32px max-w-480px>
              Vystavení platebního příkazu je jednoduché a zabere Vám necelou minutu.
            </p>
            <div flex gap-12px flex-col md:flex-row>
              <FButton :data-test="getCypressId('more-button')" name="invoice-more" size="lg" px-60px @click="scrollToContact">
                Více informací
              </FButton>
            </div>
          </div>

          <div place-self-center relative>
            <div relative>
              <NuxtImg :src="`${'/img/macbook-2.webp'}`" alt="" z-1 relative />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="light" w-full bg-neutral-900 py-60px py-80px>
      <div class="fubex-container">
        <div grid class="grid-cols-[repeat(auto-fit,minmax(200px,270px))]" place-items-center justify-center text-center gap-32px sm:gap-40px>
          <WidgetOverlimitHighlight v-for="(item, index) in invoiceHighlights" :key="index" :title="item.title" :text="item.text" :icon="item.icon" />
        </div>
      </div>
    </div>
    <div class="fubex-container">
      <div :data-test="getCypressId('how-it-works-header')" flex flex-col gap-24px items-center text-center mt="32px lg:86px" md:mt-116px mb-48px>
        <h2 heading1 text-neutral-900 font-700>
          Jak to funguje ?
        </h2>
        <p text-neutral-700 paragraph-md max-w-648px>
          Je to opravdu snadné. Založte si firemní účet ještě dnes a rozšiřte své platební možnosti. Zdarma a bez poplatků.
        </p>
      </div>
      <WidgetOverlimitHowItWork />
    </div>
    <div :data-test="getCypressId('partners')" flex flex-col gap-48px items-center text-center mt="32px lg:86px" md:mt-116px mb-48px>
      <h2 heading1 text-neutral-900 font-700>
        Naši partneři
      </h2>
      <WidgetPartnerCarousel />
      <h4 paragraph-sm text-neutral-700>
        a mnoho dalších partnerů využívá naše služby
      </h4>
    </div>
    <div ref="contactRef" />
    <WidgetContactForm>
      <h2 heading2 font-700 text-white my-12px>
        Konzultace zdarma
      </h2>
      <div text-white>
        Chcete začít přijímat kryptoměny a máte stále dotazy?
      </div>
      <div text-white>
        Zanechte nám Váš kontakt a my se Vám ozveme!
      </div>
    </WidgetContactForm>
  </div>
</template>
